import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import CreateMomentForm from './CreateMomentForm';
import NewWhisperForm from './NewWhisperForm';
import { useTranslation } from 'react-i18next';

const CreateContentModal = ({ onClose, initialText, onPostSuccess }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('whisper');

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50" onClick={onClose}>
            <div className="bg-gray-900/80 p-6 rounded-lg shadow-glow max-w-lg w-full border border-purple-500/50" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-bold text-white font-playfair">{t('createContentModal.create')}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white">
                        <LucideIcons.X size={24} />
                    </button>
                </div>
                <div className="flex border-b border-gray-700 mb-4">
                    <button 
                        className={`px-4 py-2 font-semibold w-1/2 ${activeTab === 'whisper' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-gray-400'}`}
                        onClick={() => setActiveTab('whisper')}
                    >
                        {t('createContentModal.newWhisper')}
                    </button>
                    <button 
                        className={`px-4 py-2 font-semibold w-1/2 ${activeTab === 'moment' ? 'text-purple-400 border-b-2 border-purple-400' : 'text-gray-400'}`}
                        onClick={() => setActiveTab('moment')}
                    >
                        {t('createContentModal.newMoment')}
                    </button>
                </div>
                <div>
                    {activeTab === 'whisper' && <NewWhisperForm initialText={initialText} onClose={onClose} onPostSuccess={onPostSuccess} />}
                    {activeTab === 'moment' && <CreateMomentForm />}
                </div>
            </div>
        </div>
    );
};

export default CreateContentModal;
